import { Component, OnInit, AfterViewInit, HostListener, ViewChildren, ViewChild, QueryList, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DesignationTableComponent } from './designation-table/designation-table.component';
import { DepartmentTableComponent } from './department-table/department-table.component';
import { OrganizationTableComponent } from './organization-table/organization-table.component';
import { PoliciesTableComponent } from './policies-table/policies-table.component';
import { LeavesTableComponent } from './leaves-table/leaves-table.component';
import { ExpenseTableComponent } from './expense-table/expense-table.component';
import { UserKpsTableComponent } from './user-kps-table/user-kps-table.component';
import { SetupTextTableComponent } from './setup-text-table/setup-text-table.component';
import { RolesSetupTableComponent } from './roles-setup-table/roles-setup-table.component';
import { UserChecksTableComponent } from './user-checks-table/user-checks-table.component';
import { SettingservicesService } from '../shared/services/settingservices/settingservices.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AddService } from '../shared/services/userservices/add.service';
import { SeederComponent } from './seeder/seeder.component';

@Component({
  selector: 'app-setting2',
  standalone: true,
  imports: [CommonModule, DesignationTableComponent, DepartmentTableComponent, OrganizationTableComponent, PoliciesTableComponent, LeavesTableComponent, ExpenseTableComponent, UserKpsTableComponent, SetupTextTableComponent, RolesSetupTableComponent, UserChecksTableComponent,SeederComponent],
  templateUrl: './setting2.component.html',
  styleUrl: './setting2.component.css'
})
export class Setting2Component implements OnInit, AfterViewInit {
  activeMenu = 'organizations';
  showSpinner = false;
  desDetail: any[] = [];
  orgDetail: any[] = [];
  depDetail: any[] = [];
  policyDetail: any[] = [];
  leaveDetail: any[] = [];
  kpsData: any[] = [];
  rolesData: any[] = [];
  checksData: any | null = null;
  textAutoData: any[] = [];
  textTypes: any[] = [];
  orgId: any = null;
  isOrganizationsLoading: boolean = false;
  isDepartmentsLoading: boolean = false;
  isDesignationsLoading: boolean = true;
  isPoliciesLoading: boolean = false;
  isLeavesLoading: boolean = false;
  isKpsLoading: boolean = false;
  isTextLoading: boolean = false;
  isRolesLoading: boolean = false;
  isChecksLoading: boolean = false;
  isSeederLoading: boolean = false;


  @ViewChildren('menuItem') menuItems!: QueryList<ElementRef>;
  @ViewChild('menuContainer') menuContainer!: ElementRef;
  office_roles: any;
  office_roles_array: any;
  countryList: any;
  @HostListener('window:resize')
  onResize() {
    setTimeout(() => this.scrollToActive(), 200);
  }
  constructor(private settings: SettingservicesService, private router: Router,
     private addService: AddService,
  ) { }

  ngOnInit(): void {

    const savedMenu = localStorage.getItem('settingsActiveMenu');
    const currentUrl = this.router?.url || '';

    // When a user visits the /new-settings URL directly, default to `organizations`
    // and ignore any previously saved tab state. Otherwise, restore saved menu.
    if (currentUrl === '/new-settings' || currentUrl.startsWith('/new-settings')) {
      this.activeMenu = 'organizations';
      localStorage.removeItem('settingsActiveMenu');
    } else if (savedMenu) {
      this.activeMenu = savedMenu;
    }

    this.getOrganization();
    this.getDesignation();
    this.getDepartments();
    this.getPolicies();
    this.getLeaves();
    this.getKpsList();
    this.getRolesList();
    this.getChecksDetail();
    this.getTextAutomation();
    this.getTextTypes();
    this.getData();
  }
  ngAfterViewInit() {
    requestAnimationFrame(() => this.scrollToActive());
  }
  // setMenu(menuName: string) {
  //   this.activeMenu = menuName;
  // }
  setMenu(menuName: string) {
    this.activeMenu = menuName;
    localStorage.setItem('settingsActiveMenu', menuName);

    setTimeout(() => this.scrollToActive(), 50);
  }
  scrollToActive() {
    if (!this.menuContainer) return;

    const container = this.menuContainer.nativeElement;

    const activeItem = this.menuItems
      .toArray()
      .find(item => item.nativeElement.classList.contains('active'));

    if (!activeItem) return;

    const el = activeItem.nativeElement;

    const containerRect = container.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();

    const offset = elRect.top - containerRect.top;

    container.scrollTo({
      top: container.scrollTop + offset - container.clientHeight / 2 + el.clientHeight / 2,
      behavior: 'smooth'
    });
  }

  getOrganization() {
    this.isOrganizationsLoading = true;
    this.settings.getorgdetail()
      .then((value) => {
        this.orgDetail = value.data;
        this.orgId = this.orgDetail?.[0]?.id ?? null;
        this.isOrganizationsLoading = false;
      })
      .catch(() => {
        this.isOrganizationsLoading = false;
        Swal.fire({
          iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
          title: 'Error fetching organizations',
          showConfirmButton: false,
          timer: 3000,
        });
      });
  }

  getDesignation() {
    this.isDesignationsLoading = true; // show skeleton

    this.settings.getDesdetail()
      .then((value) => {
        this.desDetail = value.data;
        this.isDesignationsLoading = false; // hide skeleton
      })
      .catch(() => {
        this.isDesignationsLoading = false;
        Swal.fire({
          iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
          title: 'Error fetching designations',
          showConfirmButton: false,
          timer: 3000,
        });
      });
  }

  getDepartments() {
    this.isDepartmentsLoading = true;
    this.settings.getdepdetail()
      .then((value) => {
        this.depDetail = value.data;
        this.isDepartmentsLoading = false;
      })
      .catch(() => {
        this.isDepartmentsLoading = false;
        Swal.fire({
          iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
          title: 'Error fetching departments',
          showConfirmButton: false,
          timer: 3000
        });
      });
  }

  getPolicies() {
    this.isPoliciesLoading = true;
    this.settings.getpolicydetail().then((value) => {
      this.policyDetail = value.data;
      this.isPoliciesLoading = false;
    }).catch(() => {
      this.isPoliciesLoading = false;
      Swal.fire({
        iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
        title: 'Error fetching policies',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  getLeaves() {
    this.isLeavesLoading = true;
    this.settings.getleavesdetail().then((value) => {
      this.leaveDetail = value?.data || [];
      this.isLeavesLoading = false;
    }).catch(() => {
      this.isLeavesLoading = false;
      Swal.fire({
        iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
        title: 'Error fetching leave details',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  getKpsList() {
    this.isKpsLoading = true;
    this.settings.getkpsData().then((value) => {
      this.kpsData = value?.data || [];
      this.isKpsLoading = false;
    }).catch(() => {
      this.isKpsLoading = false;
      Swal.fire({
        iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
        title: 'Error fetching KPS list',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  getRolesList() {
    this.isRolesLoading = true;
    this.settings.getUSerRole().then((value) => {
      if (value?.success === true) {
        this.rolesData = (value?.data || []).map((role: any) => ({
          ...role,
          parsedUserRoles: this.parseUserRoles(role.user_roles)
        }));
      } else {
        Swal.fire({
          iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
          title: value?.message || 'Error fetching user roles',
          showConfirmButton: false,
          timer: 3000,
        });
      }
      this.isRolesLoading = false;
    }).catch(() => {
      this.isRolesLoading = false;
      Swal.fire({
        iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
        title: 'Error fetching user roles',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  parseUserRoles(user_roles: any): any {
    try {
      if (typeof user_roles === 'string') {
        return JSON.parse(user_roles);
      }
      return user_roles;
    } catch {
      return null;
    }
  }

  getChecksDetail() {
    this.isChecksLoading = true;
    this.settings.getkeysdetail().then((value) => {
      const data = value?.data || null;
      if (data) {
        this.checksData = {
          id: data.id,
          device_check: data.device_check === 1 || data.device_check === '1' || data.device_check === true,
          leave_check: data.leave_check === 1 || data.leave_check === '1' || data.leave_check === true,
          authenticator_key: data.authenticator_key === 1 || data.authenticator_key === '1' || data.authenticator_key === true,
          leave_modify_date: data.leave_modify_date || null
        };
      } else {
        this.checksData = null;
      }
      this.isChecksLoading = false;
    }).catch(() => {
      this.isChecksLoading = false;
      Swal.fire({
        iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
        title: 'Error fetching checks details',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  getTextAutomation() {
    this.isTextLoading = true;
    this.settings.getTextAuto().then((value) => {
      this.textAutoData = value?.data ?? [];
      this.isTextLoading = false;
    }).catch(() => {
      this.isTextLoading = false;
      Swal.fire({
        iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
        title: 'Error fetching automation texts',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  getTextTypes() {
    this.showSpinner = true;
    this.settings.getTypeHere().then((data) => {
      if (data?.success === true) {
        this.textTypes = data?.data ?? [];
      }
      this.showSpinner = false;
    }).catch(() => {
      this.showSpinner = false;
    });
  }

  handleAddDesignation(data: any) {
   this.isDesignationsLoading = true;
    this.settings.desdetail(data).then((value) => {
      this.isDesignationsLoading = false;
      if (value.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Designation Added Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getDesignation();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isDesignationsLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error adding designation',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleEditDesignation(event: { id: any, data: any }) {
    this.isDesignationsLoading = true;
    this.settings.desedit(event.data, event.id).then((value) => {
      this.isDesignationsLoading = false;
      if (value.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Designation Edit Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getDesignation();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isDesignationsLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error updating designation',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleDeleteDesignation(id: any) {
    this.isDesignationsLoading = true;
    this.settings.getdesdelete(id).then((value) => {
      this.isDesignationsLoading = false;
      if (value.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getDesignation();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    }).catch(() => {
      this.isDesignationsLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error deleting designation',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleAddDepartment(data: any) {
    this.isDepartmentsLoading = true;
    this.settings.depCreat(data).then((value) => {
      this.isDepartmentsLoading = false;
      if (value.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Department Added Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getDepartments();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isDepartmentsLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error adding department',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleEditDepartment(event: { id: any, data: any }) {
    this.isDepartmentsLoading = true;
    this.settings.depedit(event.data, event.id).then((value) => {
      this.isDepartmentsLoading = false;
      if (value.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deparment Edit Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getDepartments();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isDepartmentsLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error updating department',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleDeleteDepartment(id: any) {
    this.isDepartmentsLoading = true;
    this.settings.getdepdelete(id).then((value) => {
      this.isDepartmentsLoading = false;
      if (value.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getDepartments();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    }).catch(() => {
      this.isDepartmentsLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error deleting department',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleAddPolicy(data: any) {
    this.isPoliciesLoading = true;
    this.settings.policyCreate(data).then((value) => {
      this.isPoliciesLoading = false;
      if (value.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Policy Added Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getPolicies();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isPoliciesLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error adding policy',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleEditPolicy(event: { id: any, data: any }) {
    this.isPoliciesLoading = true;
    this.settings.policyedit(event.data, event.id).then((value) => {
      this.isPoliciesLoading = false;
      if (value.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Designation Edit Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getPolicies();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isPoliciesLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error updating policy',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleDeletePolicy(id: any) {
    this.isPoliciesLoading = true;
    this.settings.getpolicydelete(id).then((value) => {
      this.isPoliciesLoading = false;
      if (value.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getPolicies();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    }).catch(() => {
      this.isPoliciesLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error deleting policy',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleAddLeave(event: { formValue: any, compulsory: boolean, gender: any, teamLeadAction: any }) {
    this.isLeavesLoading = true;
    this.settings.leaveCreate(event.formValue, event.compulsory, event.gender, event.teamLeadAction).then((value) => {
      this.isLeavesLoading = false;
      if (value.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: value?.message,
          showConfirmButton: false,
          timer: 5000,
        });
        this.getLeaves();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 5000,
        });
      }
    }).catch(() => {
      this.isLeavesLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error adding leave',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleEditLeave(event: { id: any, formValue: any, compulsory: boolean, gender: any, teamLeadAction: any }) {
    this.isLeavesLoading = true;
    this.settings.leavesedit(event.formValue, event.id, event.compulsory, event.gender, event.teamLeadAction).then((value) => {
      this.isLeavesLoading = false;
      if (value.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
        this.getLeaves();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isLeavesLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error updating leave',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleDeleteLeave(id: any) {
    this.isLeavesLoading = true;
    this.settings.leavedelete(id).then((value) => {
      this.isLeavesLoading = false;
      if (value.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getLeaves();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    }).catch(() => {
      this.isLeavesLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error deleting leave',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleAddKps(data: any) {
    this.isKpsLoading = true;
    this.settings.kpsCreate(data).then((value) => {
      this.isKpsLoading = false;
      if (value.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'KPS Added Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getKpsList();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isKpsLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error adding KPS',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleEditKps(event: { id: any, data: any }) {
    this.isKpsLoading = true;
    this.settings.kpsListedit(event.data, event.id).then((value) => {
      this.isKpsLoading = false;
      if (value.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'KPS Edit Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getKpsList();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isKpsLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error updating KPS',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleDeleteKps(id: any) {
    this.isKpsLoading = true;
    this.settings.getkpsdelete(id).then((value) => {
      this.isKpsLoading = false;
      if (value.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getKpsList();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    }).catch(() => {
      this.isKpsLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error deleting KPS',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleDeleteRole(id: any) {
    this.isRolesLoading = true;
    const role_id = id;
    this.settings.deleteUSerRole(role_id).then((value) => {
      this.isRolesLoading = false;
      if (value?.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: value?.message || 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getRolesList();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value?.message || 'Failed to delete role',
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isRolesLoading = false;
      Swal.fire({
        iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
        title: 'Unexpected error occurred.',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleEditRole(data: any) {
    this.router.navigate(['/user-role'], {
      state: { data }
    });
  }

  handleRoleCreated() {
    this.getRolesList();
  }

  handleSaveChecks(event: { id?: any, device_check: boolean, leave_check: boolean, auth_key: boolean, leave_date: string | null }) {
    this.isChecksLoading = true;
    const { id, device_check, leave_check, auth_key, leave_date } = event;
    const exec = id != null
      ? this.settings.keysedit(device_check, leave_check, auth_key, leave_date, id)
      : this.settings.checkCreate(device_check, leave_check, auth_key, leave_date);
    exec.then((value) => {
      this.isChecksLoading = false;
      if (value?.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: value?.message || 'Saved Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getChecksDetail();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value?.message || 'Failed to save',
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isChecksLoading = false;
      Swal.fire({
        iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
        title: 'Unexpected error occurred.',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleDeleteChecks(id: any) {
    this.isChecksLoading = true;
    this.settings.getkeydelete(id).then((value) => {
      this.isChecksLoading = false;
      if (value?.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getChecksDetail();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value?.message || 'Failed to delete',
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isChecksLoading = false;
      Swal.fire({
        iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
        title: 'Unexpected error occurred.',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleAddAutomation(payload: { id: any, text: string, org_id: any }) {
    this.isTextLoading = true;
    this.settings.createAutomationText(payload).then((value) => {
      this.isTextLoading = false;
      if (value?.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Automation Text Added Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getTextAutomation();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value?.message || 'Failed to add automation text',
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isTextLoading = false;
      Swal.fire({
        iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
        title: 'Unexpected error occurred.',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleEditAutomation(event: { id: any, data: { id: any, text: string, org_id: any } }) {
    this.isTextLoading = true;
    this.settings.editAutomationText(event.data, event.id).then((value) => {
      this.isTextLoading = false;
      if (value?.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Automation Text Edit Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getTextAutomation();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value?.message || 'Failed to edit automation text',
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isTextLoading = false;
      Swal.fire({
        iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
        title: 'Unexpected error occurred.',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleDeleteAutomation(id: any) {
    this.isTextLoading = true;
    this.settings.delTextAutomation(id).then((value) => {
      this.isTextLoading = false;
      if (value?.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getTextAutomation();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value?.message || 'Failed to delete automation text',
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isTextLoading = false;
      Swal.fire({
        iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
        title: 'Unexpected error occurred.',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  // Organization Handlers
  handleAddOrganization(data: any) {
    this.isOrganizationsLoading = true;
    this.settings.orgdetail(data).then((value) => {
      this.isOrganizationsLoading = false;
      if (value?.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Organization Added Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getOrganization();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value?.message || 'Failed to add organization',
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isOrganizationsLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error adding organization',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleEditOrganization(event: { id: any, data: any }) {
    this.isOrganizationsLoading = true;
    this.settings.orgedit(event.data, event.id).then((value) => {
      this.isOrganizationsLoading = false;
      if (value?.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Organization Edit Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getOrganization();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value?.message || 'Failed to update organization',
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isOrganizationsLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error updating organization',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

  handleDeleteOrganization(id: any) {
    this.isOrganizationsLoading = true;
    this.settings.getorgdelete(id).then((value) => {
      this.isOrganizationsLoading = false;
      if (value?.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getOrganization();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value?.message || 'Failed to delete organization',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    }).catch(() => {
      this.isOrganizationsLoading = false;
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Error deleting organization',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

   getData() {
    this.addService.getStaticData().then((value) => {
      this.office_roles = value.data.officeRolesId
      this.office_roles_array = Object.entries(this.office_roles).map(([id, role_names]) => {
        return { id: Number(id), role_names };
      });
      this.countryList = value.data.country;
    });
  }



  handleaddSeeder(data: any) {
    this.isSeederLoading = true;
    this.settings.addSeeder(data).then((value) => {
      this.isSeederLoading = false;
      if (value?.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Seeder Added Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: 'Failed to Add Seeder Data',
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.isSeederLoading = false;
      Swal.fire({
        iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
        title: 'Unexpected error occurred.',
        showConfirmButton: false,
        timer: 3000,
      });
    });
  }

}
